export default __webpack_public_path__ + "static/media/AssetImageIcon.358a860a.svg";